// @flow

export const FULL_SIZE = -1
